import React, { useState } from 'react';
import { Container, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { useParams, useNavigate } from "react-router";
import { ArrowLeft } from "react-feather";
import CustomerDashboard from './CustomerDashboard';
import CustomerProfileSetting from './CustomerProfileSetting';
import useTransaction from './useTransactionHook';
import TransactionModal from './TransactionModal';

const CustomerProfile = () => {
  const [activeTab, setActiveTab] = useState('1');
  const navigate = useNavigate();
  const { userId } = useParams();
  const transaction = useTransaction();

  return (
    <Container fluid={true} className="mt-4 pt-3">
      <Row>
        <Col sm="12">
          <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
            <div className="back-btn-container text-dark d-flex align-items-center" onClick={() => navigate(-1)} style={{cursor: 'pointer'}}>
              <ArrowLeft size={20} className="me-2" />
              <span style={{ fontWeight: 600 }}>Back</span>
            </div>
            <Nav tabs className="border-0">
              <NavItem>
                <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')} style={{cursor: 'pointer'}}>
                  Dashboard View
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => setActiveTab('2')} style={{cursor: 'pointer'}}>
                  Profile Settings
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <CustomerDashboard transactionHook={transaction} />
            </TabPane>
            <TabPane tabId="2">
              <CustomerProfileSetting userId={userId} />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
      <TransactionModal hook={transaction} />
    </Container>
  );
};

export default CustomerProfile;